import { EstateSelectCardTypes } from "@/domains/estate/constants/estateSelectCardTypes";
import { Estate } from "@/domains/estate/slice";
import EstateSlot from "@/domains/estate/components/slots/EstateSlot.tsx";

type Props = {
  estates: Estate[];
  changeSelectedEstateId: (id: number) => void;
  count: number;
  maxCount: number;
  setPurchaseModal: (arg0: boolean) => void;
};

export default function EstateSlots({
  estates,
  changeSelectedEstateId,
  count,
  maxCount,
  setPurchaseModal,
}: Props) {
  return (
    <div className="relative grow inset-0">
      <div className="absolute top-0 left-0 bottom-0 grid grid-cols-3 auto-rows-min gap-[0.9375rem] overflow-x-clip w-[calc(100%+1.0625rem)] pr-[0.8125rem] overflow-y-auto [--scrollbar-track-bg:#181818] [--scrollbar-thumb-bg:#434242] [scrollbar-gutter:stable]">
        {new Array(maxCount)
          .fill(null)
          .map((_, index) => index)
          .map((index) => {
            const estate = estates[index];

            if (estate) {
              return (
                <EstateSlot
                  key={estate.id}
                  type={EstateSelectCardTypes.Purchased}
                  estate={estate}
                  changeSelectedEstateId={changeSelectedEstateId}
                  isResident={estate.isResident}
                />
              );
            }

            if (index + 1 <= count) {
              return <EstateSlot key={index} type={EstateSelectCardTypes.Empty} />;
            }

            return (
              <EstateSlot
                key={index}
                type={EstateSelectCardTypes.Blocked}
                setPurchaseModal={setPurchaseModal}
              />
            );
          })}
      </div>
    </div>
  );
}
